import type { Balance } from '@src/types';
import type { RelatedEntitiesConfig } from '@talos/kyoko';

/**
 * Show JSON related tabs for balance rows. Currency only — balances are not
 * keyed by a Security symbol.
 */
export function getBalanceRelatedEntitiesConfig(): RelatedEntitiesConfig<Balance> {
  return {
    symbolSources: [
      {
        id: 'Currency',
        title: 'Currency',
        getSymbol: (row: Balance) => row.Currency,
        lookup: 'currency',
      },
    ],
  };
}
